<template>
    <div>
        <label :for="id" class="label text-left"><strong>{{labelText}}</strong></label>
        <div class="input-group mb-3">
            <textarea v-if="inputType==='textarea'" class="form-control" rows="5" :value="value" :placeholder="placeholder"  @input="$emit('input', $event.target.value)" :required="required"></textarea>
            <input v-else :id="id" :type="inputType" class="form-control" :value="value" :placeholder="placeholder" @input="$emit('input', inputType === 'url' ? ('http://'+$event.target.value.replace('http://','').replace('https://','')):$event.target.value)" :required="required" :min="min" :max="max" :disabled="disabled"/>
            <div class="input-group-append" v-if="required || (value+'').trim()">
                <span v-if="inputType === 'text'" class="input-group-text" v-bind:class="value.trim() ? 'text-success' : ''" v-b-tooltip.hover :title="tooltipTitle">
                    <font-awesome-icon style="margin: auto" :icon="value.trim() ? 'check' : 'exclamation'"/>
                </span>
                <span v-else-if="inputType === 'email'" class="input-group-text" v-bind:class="EMAIL_REGEX.test(value) ? 'text-success' : ''" v-b-tooltip.hover :title="tooltipTitle">
                    <font-awesome-icon style="margin: auto" :icon="EMAIL_REGEX.test(value) ? 'check' : 'exclamation'"/>
                </span>
                <span v-else-if="inputType === 'url'" class="input-group-text" v-bind:class="URL_REGEX.test(value) ? 'text-success' : ''" v-b-tooltip.hover :title="tooltipTitle">
                    <font-awesome-icon style="margin: auto" :icon="URL_REGEX.test(value) ? 'check' : 'exclamation'"/>
                </span>
                <span v-else-if="inputType === 'password'" class="input-group-text" v-bind:class="value.length>7 && extraValidation ? 'text-success' : ''" v-b-tooltip.hover :title="tooltipTitle">
                    <font-awesome-icon style="margin: auto" :icon="value.length>0 && extraValidation ? 'check' : 'exclamation'"/>
                </span>
                <span v-else-if="inputType === 'number'" class="input-group-text" v-bind:class="((min ? value>=min : true) && (max ? vale<=max : true)) ? 'text-success' : ''" v-b-tooltip.hover :title="tooltipTitle">
                    <font-awesome-icon style="margin: auto" :icon="(min ? value>=min : true) && (max ? vale<=max : true) && extraValidation ? 'check' : 'exclamation'"/>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {EMAIL_REGEX, URL_REGEX} from '@/store/constant';
export default {
    name: "FormInput",
    props: {
        labelText: String,
        placeholder: String,
        value: {type: [String, Number], default: ''},
        inputType: {type: String, default: 'text'},
        required: {type: Boolean, default: false},
        tooltipTitle: String,
        extraValidation: {type: Boolean, default: true},
        min: Number,
        max: Number,
        disabled: Boolean
    },
    data() {
        return {
            EMAIL_REGEX,
            URL_REGEX,
            id: Date.now() + '-' + Math.random().toString(36).substring(7)
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.label {
    font-size: 0.8em;
    display: block;
    margin: 0;
    margin-left: 10px;
}
.input-group-text {
    width: 45px;
}
</style>